import { AudienceSyncTimeBasedSchedule, BaseAudience } from '@/models/audiences';
import { FC } from 'react';
import { TFunction, useTranslation } from 'react-i18next';

type ScheduleTypeColumnProps = {
  audience: BaseAudience;
};

const renderScheduledSync = (audience: BaseAudience, t: TFunction) => {
  const syncConfig = audience.scheduleConfiguration as AudienceSyncTimeBasedSchedule;
  const cardinality: string = syncConfig.repeatsEvery === 1 ? 'one' : 'other';

  return t(`table.syncs.scheduled_${syncConfig.unit}_${cardinality}` as any, { count: syncConfig.repeatsEvery });
};

export const ScheduleTypeColumn: FC<ScheduleTypeColumnProps> = ({ audience }) => {
  const { t } = useTranslation('audiences');

  const renderSync = () => {
    switch (audience.scheduleType) {
      case 'REALTIME':
        return t('table.syncs.realtime');

      case 'MANUAL':
        return t('table.syncs.manual');

      case 'SCHEDULED':
        return renderScheduledSync(audience, t);

      default:
        return '-';
    }
  };

  return (
    <div className='rounded-md border border-gray-150 bg-gray-25 px-1.5 py-0.5'>
      <p className='text-xs font-medium text-gray-650 first-letter:capitalize'>{renderSync()}</p>
    </div>
  );
};
